import '~/pages/projects/merge_requests/index';
import initPremiumMessageDuringTrial from 'ee/vue_shared/premium_message_during_trial';

initPremiumMessageDuringTrial();
